import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactNode } from 'react';
import '../i18n';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (!(error instanceof Error)) {
          return failureCount < 1;
        }
        const message = error.message || '';
        // Don't retry auth, edge/origin, or transport-level failures.
        if (
          message.includes('401') ||
          message.includes('403') ||
          message.includes('5') ||
          message.includes('Network Error') ||
          message.includes('Failed to fetch') ||
          message.includes('ERR_QUIC_PROTOCOL_ERROR')
        ) {
          return false;
        }
        return failureCount < 1;
      },
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
    },
  },
});

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}
